"use client";

import React from "react";

export function MosaicBackground() {
  return (
    <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden opacity-[0.02]">
      <svg
        className="w-full h-full min-h-screen"
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="blueprint-mosaic"
            width="200"
            height="200"
            patternUnits="userSpaceOnUse"
          >
            {/* Paper Base Fill */}
            <rect width="200" height="200" fill="#F7F7F5" />
            
            {/* Interlocking Panel Hairlines */}
            <path
              d="M 0 0 L 200 0 L 200 200 L 0 200 Z
                 M 100 0 L 100 200
                 M 0 100 L 200 100
                 M 50 0 L 50 100
                 M 150 100 L 150 200
                 M 0 150 L 100 150
                 M 100 50 L 200 50"
              fill="none"
              stroke="#3A3A38"
              strokeWidth="0.75"
              strokeOpacity="1"
            />
            
            {/* Sub-grid hairline crosshairs */}
            <circle cx="100" cy="100" r="2" fill="#3A3A38" fillOpacity="1" />
            <circle cx="50" cy="50" r="2" fill="#3A3A38" fillOpacity="1" />
            <circle cx="150" cy="150" r="2" fill="#3A3A38" fillOpacity="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#blueprint-mosaic)" />
      </svg>
    </div>
  );
}
